/*
 * @Author: zhangyuan your_email
 * @Date: 2024-11-22 17:55:14
 * @LastEditors: zhangyuan your_email
 * @LastEditTime: 2024-12-03 18:30:35
 * @FilePath: /report-optimus-h5/src/util/common.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

export default {
    // ,list，code，key
    /**
     * 通过code在list中查找对应的该code的值
     * @param list 表示数据源
     * @param code 表示要获取的字段名称
     * @param key 表示返回的字段（可选），默认返回value的值
     * @param type 表示返回的实体（可选），1则返回实体整体，默认返回value
     * @returns 
     */
    getDataByCode: function (list, code, key = 'value', type) {
        // console.log('getDataByCode:', list, code, key);
        list = list || [];
        let getItem = list.find(item => item.code === code);
        if (!getItem) {
            return '';
        }
        if (type === 1) {
            return getItem;
        } else {
            return getItem[key];
        }
    }
}